import React from 'react';
import { NavigateLegacy as Navigate } from '@leagueplatform/routing';
import { toastActions, TOAST_STATUS } from '@leagueplatform/toast-messages';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useWalletParams } from '#hooks/use-wallet-params.hook.ts';
import { isValidDeepLinkId as getIsValidDeepLinkId } from '#pages/wallet-detail/utils/is-valid-deep-link-id.util.ts';
import { useGetWalletItemIdQuery } from '../../pages/wallet-detail/hooks/queries/use-get-wallet-item-id.query.hook';

export const DeepLinkWrapper = ({ children }: { children: JSX.Element }) => {
  const { userId, benefitId = '' } = useWalletParams();
  const isValidDeepLinkId = getIsValidDeepLinkId(benefitId);
  const {
    data: deepLinkId,
    isInitialLoading,
    isError,
  } = useGetWalletItemIdQuery(userId, benefitId, {
    select: (deepLinkResponse) => deepLinkResponse.wallet_item_id,
    enabled: isValidDeepLinkId,
  });

  if (isInitialLoading) {
    return <LoadingIndicator />;
  }

  if (isError) {
    toastActions.add({
      type: TOAST_STATUS.ERROR,
      shouldAutoClose: true,
      contentId: 'UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG',
    });
    return <Navigate to="./" replace />;
  }

  if (deepLinkId && isValidDeepLinkId) {
    return <Navigate to={`./${deepLinkId}`} replace />;
  }

  return children;
};
